import { useDispatch, useSelector } from 'react-redux';
import { selectSecondaryFilter, updateSecondaryFilter } from '../../features/secondaryFilter/secondaryFilterSlice';
import { selectFilterData } from '../../features/mainFilter/selectors';
import { useEffect } from 'react';

export default function useUpdateSecondaryFilterBasenOnWhatFilter () {
  const dispatch = useDispatch();
  const { data: secondaryFilter } = useSelector(selectSecondaryFilter);
  const { searchEngine } = useSelector(selectFilterData);
  const { what } = searchEngine;
  const { facilities, board } = secondaryFilter;

  const updateFacilities = (what) => {
    const activeWhatFilters = what?.filter(({ active }) => active);

    if (activeWhatFilters?.length === 0) return undefined;

    const updatedLocalState = facilities?.map((facility) => {
      return activeWhatFilters.find((filter) => filter.included_facilities?.includes(+facility.value))
        ? { ...facility, active: true }
        : facility;
    });

    dispatch(
      updateSecondaryFilter({
        updatedValue: updatedLocalState,
        filter: 'facilities',
        noChangeLastChanged: true,
      })
    );
  };

  const updateBoardType = (what) => {
    const activeWhatFilters = what?.filter(({ active }) => active);
    //if (activeWhatFilters?.length === 0) return undefined;

    if (activeWhatFilters?.length === 0) return;

    if (activeWhatFilters?.filter((filter) => filter.included_boardtype.length > 0)?.length === 0) return;

    const updatedLocalState = board?.map((boardItem) => {
      return activeWhatFilters.find((filter) => filter.included_boardtype?.includes(boardItem.value))
        ? { ...boardItem, active: true }
        : { ...boardItem, active: false };
    });

    dispatch(
      updateSecondaryFilter({
        updatedValue: updatedLocalState,
        filter: 'board',
        noChangeLastChanged: true,
      })
    );
  };

  useEffect(() => {
    updateFacilities(what);
    updateBoardType(what);
  }, [what])

  return null;
};
